import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles, BookOpen, Footprints, Home, Target, Megaphone, CalendarCheck } from 'lucide-react';
const BONUSES = [{
  num: 1,
  title: 'Lectura de Partido para Arqueros',
  subtitle: 'Cómo anticipar jugadas antes que ocurran.',
  value: '$9.990',
  icon: BookOpen
}, {
  num: 2,
  title: 'Juego con los Pies para Arqueros Modernos',
  subtitle: 'Cómo convertirte en el primer creador de juego del equipo.',
  value: '$9.990',
  icon: Footprints
}, {
  num: 3,
  title: 'Entrenamiento de Reacción en Casa',
  subtitle: 'Cómo mejorar reflejos sin necesidad de cancha.',
  value: '$7.990',
  icon: Home
}, {
  num: 4,
  title: 'Guía de Posicionamiento Inteligente',
  subtitle: 'Cómo parecer más rápido simplemente posicionándote mejor.',
  value: '$7.990',
  icon: Target
}, {
  num: 5,
  title: 'El Manual del Arquero Líder',
  subtitle: 'Comunicación, presencia y autoridad dentro del equipo.',
  value: '$6.990',
  icon: Megaphone
}, {
  num: 6,
  title: 'Plan de Evolución de 30 Días',
  subtitle: 'Sistema paso a paso para convertirte en un arquero más completo.',
  value: '$9.990',
  icon: CalendarCheck
}];
export const BonusesSection = () => {
  return <section className="py-16 md:py-24 px-4 relative overflow-hidden bg-gradient-to-b from-forest-950 via-forest-900 to-forest-950 border-y border-grass-400/30" data-id="element-11">
      {/* Decorative glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-grass-400/10 blur-[120px] rounded-full pointer-events-none" data-id="element-12" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-grass-400/10 blur-[120px] rounded-full pointer-events-none" data-id="element-13" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-14">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-15">
          <motion.div animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="inline-flex items-center justify-center gap-2 bg-red-500 text-white font-anton uppercase tracking-wider text-sm px-5 py-2 rounded-full mb-5 shadow-[0_0_20px_rgba(239,68,68,0.5)]" data-id="element-16">
            <Sparkles size={16} className="fill-white" data-id="element-17" />
            ¡Atención! Solo por el día de hoy
            <Sparkles size={16} className="fill-white" data-id="element-18" />
          </motion.div>

          <h2 className="font-anton text-4xl md:text-6xl text-white uppercase tracking-wide leading-tight mb-4" data-id="element-19">
            6 BONOS <span className="text-grass-400" data-id="element-20">100% GRATIS</span>
            <br className="hidden md:block" data-id="element-21" />
            <span className="text-2xl md:text-4xl" data-id="element-22">si comprás hoy</span>
          </h2>

          <p className="text-forest-200 text-base md:text-lg max-w-2xl mx-auto" data-id="element-23">
            Sumá{' '}
            <span className="text-grass-400 font-bold" data-id="element-24">
              más de $52.940 en contenido extra
            </span>{' '}
            sin pagar un peso adicional.
          </p>
        </motion.div>

        {/* Bonuses grid */}
        <div className="grid md:grid-cols-2 gap-4 md:gap-5 mb-10" data-id="element-25">
          {BONUSES.map((bonus, i) => {
          const Icon = bonus.icon;
          return <motion.div key={bonus.num} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="relative bg-gradient-to-br from-forest-900 to-forest-950 border-2 border-grass-400/40 p-5 rounded-xl group hover:border-grass-400 hover:shadow-[0_0_25px_rgba(130,194,72,0.3)] transition-all overflow-hidden" data-id="element-26">
                {/* GRATIS badge */}
                <div className="absolute -top-1 -right-1 z-10" data-id="element-27">
                  <div className="relative" data-id="element-28">
                    <div className="bg-red-500 text-white font-anton text-xs uppercase tracking-wider px-3 py-1.5 rounded-bl-xl rounded-tr-xl shadow-lg" data-id="element-29">
                      🎁 GRATIS HOY
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-4 pr-20" data-id="element-30">
                  <div className="bg-grass-400/15 border border-grass-400/30 p-3 rounded-lg shrink-0 group-hover:bg-grass-400/25 transition-colors" data-id="element-31">
                    <Icon className="text-grass-400" size={24} data-id="element-32" />
                  </div>
                  <div className="flex-1" data-id="element-33">
                    <div className="text-grass-400 font-anton text-xs tracking-wider mb-1" data-id="element-34">
                      BONO #{bonus.num}
                    </div>
                    <h3 className="font-bold text-base md:text-lg text-white mb-1.5 leading-tight" data-id="element-35">
                      {bonus.title}
                    </h3>
                    <p className="text-forest-300 text-sm mb-3" data-id="element-36">
                      {bonus.subtitle}
                    </p>
                    <div className="flex items-center gap-2 text-sm" data-id="element-37">
                      <span className="text-forest-400" data-id="element-38">Valor:</span>
                      <span className="text-forest-400 line-through font-semibold" data-id="element-39">
                        {bonus.value}
                      </span>
                      <span className="text-grass-400 font-anton uppercase tracking-wide" data-id="element-40">
                        Hoy GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Total value highlight */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-xl mx-auto bg-forest-950 border-2 border-grass-400 rounded-2xl p-6 text-center shadow-[0_0_30px_rgba(130,194,72,0.25)]" data-id="element-41">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-42">
            <Gift className="text-grass-400" size={20} data-id="element-43" />
            <p className="text-forest-200 text-sm md:text-base font-semibold uppercase tracking-wider" data-id="element-44">
              Valor total de los bonos
            </p>
          </div>
          <p className="text-forest-400 line-through text-xl font-bold" data-id="element-45">
            $52.940
          </p>
          <p className="font-anton text-4xl md:text-5xl text-grass-400 tracking-wide mt-1" data-id="element-46">
            HOY: $0
          </p>
          <p className="text-xs text-forest-400 mt-2 uppercase tracking-wider" data-id="element-47">
            Incluidos al comprar Arquero PRO System
          </p>
        </motion.div>
      </div>
    </section>;
};